import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { ClaimAccountEntitlementEmployeeFileHelperContainerModel } from '../../../../../../models/aggregates/erp/claim-account-file-import/index';

@Injectable({
  providedIn: 'root'
})
export class ClaimAccountEntitlementEmployeeFileHelperService extends BaseApiTemplateService<ClaimAccountEntitlementEmployeeFileHelperContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'account-entitlement-employee/import-file-helpers/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'account-entitlement-employee/import-file-helpers/backoffice-ep';
    this.httpClient = http;
  }
}